import PageLayout from '@/components/shared/PageLayout';
import CoachingContent from "@/components/coaching-content";

export default function CoachingPage() {
  return (
    <PageLayout
      title="Coaching"
      subtitle="Coaching principles and resources"
    >
      <CoachingContent />
    </PageLayout>
  );
}
